import React from "react"
import Layout from "../components/layout"
import { Helmet } from "react-helmet"
import { Link } from "gatsby"
import HeaderBanner from "../components/headerbanner"
import SEOHeader from "../components/seo-header"

export default () => (
  <div>
    <SEOHeader
      title="FAQ | Frequently Asked Questions On Booking, Cancellation etc."
      description="Here are some of the questions that you may have in mind. We are always around over chat, phone or email if you have other questions."
      socialURL="https://assets.gofloaters.com/socialimage/homepage.jpg"
      pinterest="true"
    ></SEOHeader>
    <Helmet>
      <script
        src="https://code.jquery.com/jquery-3.4.1.slim.min.js"
        integrity="sha384-J6qa4849blE2+poT4WnyKhv5vZF5SrPo0iEjwBvKU7imGFAV0wwj1yYfoRSJoZ+n"
        crossorigin="anonymous"
        defer
      ></script>
      <script
        src="https://cdn.jsdelivr.net/npm/popper.js@1.16.0/dist/umd/popper.min.js"
        integrity="sha384-Q6E9RHvbIyZFJoft+2mJbHaEWldlvI9IOYy5n3zV9zzTtmI3UksdQRVvoxMfooAo"
        crossorigin="anonymous"
        defer
      ></script>
      <script
        src="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/js/bootstrap.min.js"
        integrity="sha384-wfSDF2E50Y2D1uUdj0O3uMBJnjuUD4Ih7YwaYd1iqfktj0Uod8GCExl3Og8ifwB6"
        crossorigin="anonymous"
        defer
      ></script>

      <script type="application/ld+json">
        {`{"@context":"https://schema.org","@type":"FAQPage","mainEntity":[{"@type":"Question","name":"What is GoFloaters?","acceptedAnswer":{"@type":"Answer","text":"GoFloaters is a hybrid workplace platform. We help teams and individuals work and meet anywhere on a pay-per-use model.\nOur enterprise product WorkqFlexi - the unified Hybrid Workplace Platform helps companies find flexible hybrid offices for their distributed teams across the country. \n\nWe currently offer access to 2000+ variety of workspaces across 35+ cities in India including Tier 2 & 3 towns."}},{"@type":"Question","name":"What does GoFloaters offer?","acceptedAnswer":{"@type":"Answer","text":"Hot desks for a day\nOur spaces are easily accessible and equipped with high-speed WiFi and power backup.\n\nCabin rooms or Meeting rooms by the hour\nIn person meetings and face to face collaborations ease the process of decision making.\n\nWorqFlexi\n\nEnable Hybrid working through WorqFlexi. Your employees get access to 1000's of professional, productive coworking spaces across India.\n\nVirtual Offices\nLooking to register your company or get GST. You don't need to rent an office for that. Get an address to register your company or get GST with our virtual offices.\n\nWe provide the most affordable virtual office service in India at Rs 900 / month.\n\nLong Term Office Rentals : If you are looking for managed office spaces\n\n"}},{"@type":"Question","name":"Why Choose GoFloaters?","acceptedAnswer":{"@type":"Answer","text":"You can book work and meeting spaces instantly on our platform. We offer the widest network of spaces thus avoiding you the woes of travel and traffic. Our superlative customer service is loved by our customers.\n \nWe have helped thousands of professionals, teams, companies and freelancers find their way into coworking for work, meetings, conferences and offsites. We pioneered the concept of coworking way back in 2017 with our work cafes starting at Rs. 20/-. Since then, GoFloaters app has been successful at providing on-demand workspaces for varied workforce including hybrid and remote professionals, consulting doctors, therapist, trainers, tutor groups, self help groups and NGOs (trust us when we say this😊) & more"}},{"@type":"Question","name":"How does GoFloaters help?","acceptedAnswer":{"@type":"Answer","text":"If you are in need of on-demand professional workspaces for you or your team instantly across GoFloaters is the app to use. You pay for only the coworking space that you choose and use. You don't need to sign any agreement or lock your money in, memberships fees or deposits.\nWe can get you the easiest access to flexible workspaces of hot desks, cabins, meeting rooms or conferences or monthly workspaces across 35+ cities and towns in India."}},{"@type":"Question","name":"What is the USP of GoFloaters?","acceptedAnswer":{"@type":"Answer","text":"Get instant access to thousands of workspaces and meeting room\nTrusted by 25,000+ customers\nPay-as-you-go, plug and play office, no contracts\nAffordable – our office starting at Rs 199 / day / person\nDistraction free and near home workspaces\nBest in class customer support available on call to help you with professional to curated spaces"}},{"@type":"Question","name":"How many coworking spaces do you feature on GoFloaters?","acceptedAnswer":{"@type":"Answer","text":"We have about 2000+ coworking spaces across India across 35+ cities in India."}},{"@type":"Question","name":"Which cities do you offer coworking spaces?","acceptedAnswer":{"@type":"Answer","text":"1. Bangalore\n2. Chennai\n3. Mumbai\n4. New Delhi\n5. Noida\n6. Gurugram\n7. Hyderabad\n8. Pune\n9. Ghaziabad\n10. Ahmedabad\n11. Coimbatore\n12. Indore\n13. Kochi\n14. Kolkata\n15. Madurai\n16. Mysore\n17. Trichy\n18. Visakhapatnam\n19. Lucknow\n20. Vijayawada\n21. Thiruvananthapuram\n22. Faridabad\n23. Vadodara\n24. Nagpur\n25. Puducherry\n26. Goa\n27. Chandigarh\n28. Agartala\n29. Ranchi\n30. Bhubaneshwar\n31. Jalandhar\n32. Bhopal\n33. Imphal\n34. Siliguri\n & more as we progress"}},{"@type":"Question","name":"How to book the coworking spaces?","acceptedAnswer":{"@type":"Answer","text":"You can select the space of your choice from our application, make the booking for your preferred time and then make the payment for the same through Credit Card, UPI and other digital wallets."}},{"@type":"Question","name":"How can I change the password in my account?","acceptedAnswer":{"@type":"Answer","text":"You can change your GoFloaters password from the login screen or our mobile app or web app. Click the “Forgot / Reset Password” link to reset your password."}},{"@type":"Question","name":"Can I delete my GoFloaters account?","acceptedAnswer":{"@type":"Answer","text":"Yes, you can delete your GoFloaters account. From the My Profile menu you can initiate the request for account deletion through the View Account option."}},{"@type":"Question","name":"What is the price of booking a coworking space?","acceptedAnswer":{"@type":"Answer","text":"At GoFloaters we make sure that our customers have the best and most pleasant working experience. The pricing for each coworking space starts from ₹199 and goes all the way up to ₹5000. This is dependent on the type of booking, space and location."}},{"@type":"Question","name":"How many types of booking are there?","acceptedAnswer":{"@type":"Answer","text":"3 types of bookings can be made.\n\nA hot desk in a coworking workplace means a comfortable work set-up that a customer can use on rent. Hot desk can be rented on day basis or long term. In other words, individual plug-and-play facilities with chairs and tables for working in an open layout. The customer can be a freelancer, any professional, or an employee from a company looking to make co-working the way of work. It is usually first cum first basis. In the new era of Hybrid work, companies have started understanding the advantages of the on-demand workspace model, the operational efficiency, space utilisation and workplace flexibility.\n\nMeeting Rooms: Professional meeting rooms to make the best impression for your team collaboration, sales meeting, trainings, workshops, pitch meeting, board meeting, HR interviews, or workshop. Book by the house or by day.\n\nOffice Spaces: Whether it is long term office for you or for your team there are office spaces for all team sixes with all inclusive pricing."}},{"@type":"Question","name":"Are there any packages or deals that GoFloaters have for its customers?","acceptedAnswer":{"@type":"Answer","text":"Not, at the moment. But we will be happy to help if your team needs customisation. Mail us at support@gofloaters.com"}},{"@type":"Question","name":"How can employees of companies get access to coworking spaces?","acceptedAnswer":{"@type":"Answer","text":"GoFloaters is the only platform in India that enables teams to manage a hybrid workplace model through WorqFlexi. Employees can get access to 1000's professional, productive coworking spaces across India. You can book these now from the website or the GoFloaters application. Management gets to provision, monitor and measure the rollout of hybrid work through the WorqFlexi dashboard."}},{"@type":"Question","name":"Can we bring guests to the coworking spaces?","acceptedAnswer":{"@type":"Answer","text":"There is no concept of +1 or guests along in coworking spaces. Except access to reception for quick meetings, coworking spaces do not entertain guests. If you want to bring an additional member, please make the extra seat booking irrespective of whether it is for a hot desk, cabin, meeting room or conference rooms."}},{"@type":"Question","name":"What are the cancellation policies on GoFloaters?","acceptedAnswer":{"@type":"Answer","text":"The following are the cancellation policies on GoFloaters.\nDaily Coworking Spaces: There are some time limits in place for cancellation. If cancelled 6 hours in advance there will be a refund in the form of future credits that can be used for your next booking. If it is cancelled within 6 hours of booking then there will be no refunds of any form. For AWFIS and WeWork day passes bookings, cancellations must be made by midnight the day before your reservation. Cowrks day pass bookings are not cancellable.\nGoFloaters Meeting Spaces: Some bookings can be cancelled 2 days in advance. There will be refunds in the form of future credits that you can use to book future meeting spaces across the city. If it is cancelled in under 2 hours then there will be no refunds of any form."}},{"@type":"Question","name":"Why isn't my booking showing up on the application? Why haven't I received a confirmation message yet?","acceptedAnswer":{"@type":"Answer","text":"After the booking is done our team is ensuring that you receive all the confirmations as immediately as the payment is done. However, there are some times when there are some technical problems that may cause an issue with the bookings of the coworking spaces. In these times we ask you to give us a considerable amount of lead time to find the issue and fix it as soon as possible. It also depends on the volume of people using the application at the time and due to this, there is a buffer of 30 minutes where the booking gets confirmed. If the booking does not get confirmed in 30 minutes then please reach out to our team and we will sort the issue for you. For any further informations on your booking query, write to us with you booking ID and details at bookings@gofloaters.com"}},{"@type":"Question","name":"What are the working times of the coworking spaces?","acceptedAnswer":{"@type":"Answer","text":"Each space has different timing as mentioned in their respective page. Most of the spaces are open between 9 am and 7 pm. For any space for 24 hours or night schedule, please get in touch with us."}},{"@type":"Question","name":"How can I list my coworking space on GoFloaters?","acceptedAnswer":{"@type":"Answer","text":"Coworking operators and space owners are welcome to list their office space with GoFloaters. We have partnered with over 1000+ coworking business owners monetising their empty spaces. If you are interested, please reach out to us for further information. It is the best way to drive revenue"}},{"@type":"Question","name":"How can my coworking space listing be edited?","acceptedAnswer":{"@type":"Answer","text":"Space partners have access through information on their space, commercials, space images that can be edited and evaluated as needed."}},{"@type":"Question","name":"What Does WorqFlexi do?","acceptedAnswer":{"@type":"Answer","text":"WorqFlexi is GoFloaters’ hybrid workplace management solution. It is a unified way to manage a flexible workplace environment for teams and companies."}},{"@type":"Question","name":"Can we see bills and other management-related tools in WorqFlexi?","acceptedAnswer":{"@type":"Answer","text":"Yes! The team owner/managers has access to this simple unified visual dashboard and tools that provides information of booking schedules, space allocations, member information, access details and invoices."}},{"@type":"Question","name":"How does GoFloaters fit in as SaaS for workplace management?","acceptedAnswer":{"@type":"Answer","text":"GoFloaters is a leading unified hybrid workplace platform. It helps managers and team owners have seamless access to every information about their workspace whereabouts of their distributed teams. Your existing office space can be managed and reserved by your team members through our tech platform that is available in the SaaS model. This integration helps them with the easiest management of flexible office space."}}]}
    `}
      </script>
    </Helmet>
    <Layout>
      <HeaderBanner>
        <h1>FAQs</h1>
      </HeaderBanner>
      <div className="container">
        <div className="row">
          <div className="col-md-12"></div>
          <div className="col-md-12 text-center">
            <p>
              Here are some of the questions that you may have in mind. We are
              always around over chat, phone or email if you have other
              questions.
            </p>
          </div>
          <ul className="nav nav-tabs" role="tablist">
            <li className="nav-item">
              <a className="nav-link active" data-toggle="tab" href="#home">
                General
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" data-toggle="tab" href="#price">
                Pricing
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" data-toggle="tab" href="#menu2">
                Booking
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" data-toggle="tab" href="#menu3">
                Listing Your Spaces
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" data-toggle="tab" href="#menu4">
                GoFloaters x WorqFlexi
              </a>
            </li>
          </ul>

          <div className="tab-content">
            <div id="home" className="container tab-pane active">
              {" "}
              <br />
              <br />
              <br />
              <p>
                <strong>What is GoFloaters?</strong>
              </p>{" "}
              <ol start="1" type="A">
                {" "}
                <li>
                  <a href="https://gofloaters.com/">GoFloaters</a> is a hybrid
                  workplace platform. We help teams and individuals work and
                  meet anywhere on a pay-per-use model.{" "}
                </li>{" "}
              </ol>{" "}
              <p>
                Our enterprise product WorkqFlexi - the unified Hybrid Workplace
                Platform helps companies find flexible hybrid offices for their
                distributed teams across the country. {" "}
              </p>{" "}
              <p>
                We currently offer access to 2000+ variety of workspaces across
                35+ cities in India including Tier 2 &amp; 3 towns.{" "}
              </p>{" "}
              <br />
              <p>
                <strong>What does GoFloaters offer?</strong>
              </p>{" "}
              <p>
                <a href="https://gofloaters.com/coworking-spaces/">Hot desks</a>{" "}
                for a day
                <br /> Our spaces are easily accessible and equipped with
                high-speed WiFi and power backup.{" "}
              </p>{" "}
              <p>
                Cabin rooms or{" "}
                <a href="https://gofloaters.com/meeting-spaces/">
                  Meeting rooms
                </a>{" "}
                by the hour
                <br /> In person meetings and face to face collaborations ease
                the process of decision making.{" "}
              </p>{" "}
              <p>
                <a href="https://gofloaters.com/worqflexi/">WorqFlexi</a>
              </p>{" "}
              <p>
                Enable Hybrid working through WorqFlexi. Your employees get
                access to 1000's of professional, productive coworking spaces
                across India.
              </p>{" "}
              <p>
                <a href="https://virtualoffice.gofloaters.com/">
                  Virtual Offices
                </a>
                <br /> Looking to register your company or get GST. You don't
                need to rent an office for that. Get an address to register your
                company or get GST with our virtual offices.{" "}
              </p>{" "}
              <p>
                We provide the most affordable virtual office service in India
                at Rs 900 / month.{" "}
              </p>{" "}
              <p>
                <a href="https://gofloaters.com/office-spaces/">
                  Long Term Office
                </a>{" "}
                Rentals : If you are looking for managed office spaces{" "}
              </p>{" "}
              <br />
              <p>
                <strong>Why Choose GoFloaters?</strong>
              </p>{" "}
              <ol start="1" type="A">
                {" "}
                <li>
                  You can book work and meeting spaces instantly on our
                  platform. We offer the widest network of spaces thus avoiding
                  you the woes of travel and traffic. Our superlative customer
                  service is loved by our customers.
                </li>{" "}
              </ol>{" "}
              <p>
                <br /> We have helped thousands of professionals, teams,
                companies and freelancers find their way into coworking for
                work, meetings, conferences and offsites. We pioneered the
                concept of coworking way back in 2017 with our work cafes
                starting at Rs. 20/-. Since then,{" "}
                <a href="https://gofloaters.com/get-the-app/">GoFloaters app</a>{" "}
                has been successful at providing on-demand workspaces for varied
                workforce including hybrid and remote professionals, consulting
                doctors, therapist, trainers, tutor groups, self help groups and
                NGOs (trust us when we say this😊) & more
              </p>{" "}
              <br />
              <p>
                <strong>How does GoFloaters help?</strong>
              </p>{" "}
              <ol start="1" type="A">
                {" "}
                <li>
                  If you are in need of on-demand professional workspaces for
                  you or your team instantly across{" "}
                  <a href="https://gofloaters.com/contact-us/">GoFloaters</a> is
                  the app to use. You pay for only the coworking space that you
                  choose and use. You don't need to sign any agreement or lock
                  your money in, memberships fees or deposits.{" "}
                </li>{" "}
              </ol>{" "}
              <p>
                We can get you the easiest access to flexible workspaces of hot
                desks, cabins, meeting rooms or conferences or monthly
                workspaces across 35+ cities and towns in India. {" "}
              </p>{" "}
              <br />
              <p>
                <strong>What is the USP of GoFloaters?</strong>
              </p>{" "}
              <ol>
                {" "}
                <li>
                  Get instant access to thousands of workspaces and meeting room
                </li>{" "}
                <li>Trusted by 25,000+ customers</li>{" "}
                <li>Pay-as-you-go, plug and play office, no contracts</li>{" "}
                <li>
                  Affordable – our office starting at Rs 199 / day / person
                </li>{" "}
                <li>Distraction free and near home workspaces </li>{" "}
                <li>
                  Best in class customer support available on call to help you
                  with professional to curated spaces{" "}
                </li>{" "}
              </ol>{" "}
              <p>
                 <br />{" "}
                <strong>
                  How many coworking spaces do you feature on GoFloaters?
                </strong>
              </p>{" "}
              <ol start="1" type="A">
                {" "}
                <li>
                  We have about 2000+ coworking spaces across India across 35+
                  cities in India.
                </li>{" "}
              </ol>{" "}
              <br />
              <p>
                <strong>Which cities do you offer coworking spaces?</strong>
                <br /> 1. Bangalore
                <br /> 2. Chennai
                <br /> 3. Mumbai
                <br /> 4. New Delhi
                <br /> 5. Noida
                <br /> 6. Gurugram
                <br /> 7. Hyderabad
                <br /> 8. Pune
                <br /> 9. Ghaziabad
                <br /> 10. Ahmedabad
                <br /> 11. Coimbatore
                <br /> 12. Indore
                <br /> 13. Kochi
                <br /> 14. Kolkata
                <br /> 15. Madurai
                <br /> 16. Mysore
                <br /> 17. Trichy
                <br /> 18. Visakhapatnam
                <br /> 19. Lucknow
                <br /> 20. Vijayawada
                <br /> 21. Thiruvananthapuram
                <br /> 22. Faridabad
                <br /> 23. Vadodara
                <br /> 24. Nagpur
                <br /> 25. Puducherry
                <br /> 26. Goa
                <br /> 27. Chandigarh
                <br /> 28. Agartala
                <br /> 29. Ranchi
                <br /> 30. Bhubaneshwar
                <br /> 31. Jalandhar
                <br /> 32. Bhopal
                <br /> 33. Imphal
                <br /> 34. Siliguri
                <br />& more as we progress
              </p>{" "}
              <p>&nbsp;</p>{" "}
              <p>
                <strong>How to book the coworking spaces?</strong>
              </p>{" "}
              <ol start="1" type="A">
                {" "}
                <li>
                  You can select the space of your choice from our application,
                  make the booking for your preferred time and then make the
                  payment for the same through Credit Card, UPI and other
                  digital wallets.{" "}
                </li>{" "}
              </ol>{" "}
              <p>&nbsp;</p>{" "}
              <p>
                <strong>
                  <u>Account Related Information</u>
                </strong>
              </p>{" "}
              <p>
                <strong>How can I change the password in my account?</strong>
              </p>{" "}
              <ol start="1" type="A">
                {" "}
                <li>
                  You can change your{" "}
                  <a href="https://gofloaters.com/">GoFloaters</a> password from
                  the login screen or our mobile app or web app. Click the
                  &ldquo;Forgot / Reset Password&rdquo; link to reset your
                  password.{" "}
                </li>{" "}
              </ol>{" "}
              <p>
                <strong>Can I delete my GoFloaters account?</strong>
              </p>{" "}
              <ol start="1" type="A">
                {" "}
                <li>
                  Yes, you can delete your GoFloaters account. From the My
                  Profile menu you can initiate the request for account deletion
                  through the View Account option.{" "}
                </li>{" "}
              </ol>
              <p> </p>
            </div>
            <div id="price" className="container tab-pane">
              {" "}
              <br />
              <br />
              <br />
              <p>
                <strong>What is the price of booking a coworking space?</strong>
              </p>
              <p>
                At GoFloaters we make sure that our customers have the best and
                most pleasant working experience. The pricing for each coworking
                space starts from ₹199 and goes all the way up to ₹5000. This is
                dependent on the type of booking, space and location.{" "}
              </p>
              <br />
              <p>
                <strong>How many types of booking are there?</strong>
              </p>
              <ol start="1" type="A">
                <li>3 types of bookings can be made. </li>
              </ol>
              <br />
              <p>
                A hot desk in a coworking workplace means a comfortable work
                set-up that a customer can use on rent.{" "}
                <a href="https://gofloaters.com/coworking-spaces/">
                  Hot desk can be rented on day basis
                </a>{" "}
                or <a href="https://gofloaters.com/office-spaces/">long term</a>
                . In other words, individual plug-and-play facilities with
                chairs and tables for working in an open layout. The customer
                can be a freelancer, any professional, or an employee from a
                company looking to make co-working the way of work. It is
                usually first cum first basis. In the new era of Hybrid work,
                companies have started understanding the advantages of the
                on-demand workspace model, the operational efficiency, space
                utilisation and workplace flexibility.
              </p>
              <p>
                <a href="https://gofloaters.com/meeting-spaces/">
                  Meeting Rooms
                </a>
                : Professional meeting rooms to make the best impression for
                your team collaboration, sales meeting, trainings, workshops,
                pitch meeting, board meeting, HR interviews, or workshop. Book
                by the house or by day.{" "}
              </p>
              <p>
                <a href="https://gofloaters.com/office-spaces/">
                  Office Spaces
                </a>
                : Whether it is long term office for you or for your team there
                are office spaces for all team sixes with all inclusive pricing.{" "}
              </p>
              <br />
              <p>
                <strong>
                  Are there any packages or deals that GoFloaters have for its
                  customers?
                </strong>
              </p>
              <ol start="1" type="A">
                <li>
                  Not, at the moment. But we will be happy to help if your team
                  needs customisation. Mail us at support@gofloaters.com
                </li>
              </ol>
              <br />
              <p>
                <strong>
                  How can employees of companies get access to coworking spaces?
                </strong>
              </p>
              <p>
                GoFloaters is the only platform in India that enables teams to
                manage a hybrid workplace model through{" "}
                <a href="https://gofloaters.com/worqflexi/">WorqFlexi</a>.
                Employees can get access to 1000's professional, productive
                coworking spaces across India. You can book these now from the{" "}
                <a href="https://gofloaters.com/">website</a> or the{" "}
                <a href="https://gofloaters.com/get-the-app/">
                  GoFloaters application
                </a>
                . Management gets to provision, monitor and measure the rollout
                of hybrid work through the WorqFlexi dashboard.
              </p>
              <br />
              <br />
            </div>
            <div id="menu2" className="container tab-pane fade">
              {" "}
              <br />
              <br />
              <p>
                <strong>Can we bring guests to the coworking spaces?</strong>
              </p>
              <ol start="1" type="A">
                <li>
                  There is no concept of +1 or guests along in coworking spaces.
                  Except access to reception for quick meetings, coworking
                  spaces do not entertain guests. If you want to bring an
                  additional member, please make the extra seat booking
                  irrespective of whether it is for a hot desk, cabin, meeting
                  room or conference rooms.{" "}
                </li>
              </ol>
              <br />
              <p>
                <strong>
                  What are the cancellation policies on GoFloaters?
                </strong>
              </p>
              <ol start="1" type="A">
                <li>
                  The following are the cancellation policies on GoFloaters.
                </li>
              </ol>
              <ol>
                <li>
                  Daily Coworking Spaces: There are some time limits in place
                  for cancellation. If cancelled 6 hours in advance there will
                  be a refund in the form of future credits that can be used for
                  your next booking. If it is cancelled within 6 hours of
                  booking then there will be no refunds of any form. For AWFIS
                  and WeWork day passes bookings, cancellations must be made by
                  midnight the day before your reservation. Cowrks day pass
                  bookings are not cancellable.
                </li>
                <li>
                  GoFloaters Meeting Spaces: Some bookings can be cancelled 2
                  days in advance. There will be refunds in the form of future
                  credits that you can use to book future meeting spaces across
                  the city. If it is cancelled in under 2 hours then there will
                  be no refunds of any form.
                </li>
              </ol>
              <br />
              <p>
                <strong>
                  Why isn't my booking showing up on the application? Why
                  haven't I received a confirmation message yet?
                </strong>
              </p>
              <ol start="1" type="A">
                <li>
                  After the booking is done our team is ensuring that you
                  receive all the confirmations as immediately as the payment is
                  done. However, there are some times when there are some
                  technical problems that may cause an issue with the bookings
                  of the coworking spaces. In these times we ask you to give us
                  a considerable amount of lead time to find the issue and fix
                  it as soon as possible. It also depends on the volume of
                  people using the application at the time and due to this,
                  there is a buffer of 30 minutes where the booking gets
                  confirmed. If the booking does not get confirmed in 30 minutes
                  then please reach out to our team and we will sort the issue
                  for you. For any further informations on your booking query,
                  write to us with you booking ID and details at{" "}
                  <a href="mailto:bookings@gofloaters.com">
                    bookings@gofloaters.com
                  </a>
                </li>
              </ol>
              <br />
              <p>
                <strong>
                  What are the working times of the coworking spaces?
                </strong>
              </p>
              <ol start="1" type="A">
                <li>
                  Each space has different timing as mentioned in their
                  respective page. Most of the spaces are open between 9 am and
                  7 pm. For any space for 24 hours or night schedule, please get
                  in touch with us.{" "}
                </li>
              </ol>
              <br />
              <br />
            </div>
            <div id="menu3" className="container tab-pane fade">
              <br />
              <br />
              <p>
                <strong>
                  How can I list my coworking space on GoFloaters?
                </strong>
              </p>
              <ol start="1" type="A">
                <li>
                  Coworking operators and space owners are welcome to list their
                  office space with GoFloaters. We have partnered with over
                  1000+ coworking business owners monetising their empty spaces.
                  If you are interested, please reach out to us for further{" "}
                  <a href="https://gofloaters.com/dont-let-space-go-to-waste/">
                    information
                  </a>
                  . It is the best way to drive revenue
                </li>
              </ol>
              <br></br>
              <p>
                <strong>How can my coworking space listing be edited?</strong>
              </p>
              <ol start="1" type="A">
                <li>
                  <a
                    href="https://spaceadmin.gofloaters.com/"
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                  >
                    Space partners
                  </a>{" "}
                  have access through information on their space, commercials,
                  space images that can be edited and evaluated as needed.{" "}
                </li>
              </ol>
              <br />
              <br />
            </div>
            <div id="menu4" className="container tab-pane fade">
              {" "}
              <br />
              <br />
              <p>
                <strong>What Does WorqFlexi do?</strong>
              </p>
              <ol start="1" type="A">
                <li>
                  WorqFlexi is GoFloaters&rsquo; hybrid workplace management
                  solution. It is a unified way to manage a flexible workplace
                  environment for teams and companies.{" "}
                </li>
              </ol>{" "}
              <br />
              <p>
                <strong>
                  Can we see bills and other management-related tools in
                  WorqFlexi?
                </strong>
              </p>
              <ol start="1" type="A">
                <li>
                  Yes! The team owner/managers has access to this simple unified
                  visual dashboard and tools that provides information of
                  booking schedules, space allocations, member information,
                  access details and invoices.{" "}
                </li>
              </ol>{" "}
              <br />
              <p>
                <strong>
                  How does GoFloaters fit in as SaaS for workplace management?
                </strong>
              </p>
              <ol start="1" type="A">
                <li>
                  GoFloaters is a leading unified hybrid workplace platform. It
                  helps managers and team owners have seamless access to every
                  information about their workspace whereabouts of their
                  distributed teams. Your existing office space can be managed
                  and reserved by your team members through our tech platform
                  that is available in the SaaS model. This integration helps
                  them with the easiest management of flexible office space.{" "}
                </li>
              </ol>
              <br></br>
              <br></br>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  </div>
)
